(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('[data-shirt-choice]');
  if (!button) return;

  const controls = button.closest('[data-shirt-type-controls]');
  const section = controls?.closest('results-list');
  if (!section || controls.dataset.loading === 'true') return;

  const grid = section.querySelector('.product-grid');
  const pages = section.querySelector('[data-shirt-pages]');
  const status = controls.querySelector('[data-shirt-status]');
  const buttons = [...controls.querySelectorAll('[data-shirt-choice]')];

  if (!grid || !pages || !status) return;

  const choice = button.dataset.shirtChoice;
  const sectionId = section.getAttribute('section-id');

  controls.dataset.loading = 'true';
  controls.setAttribute('aria-busy', 'true');
  buttons.forEach((item) => {
    item.disabled = true;
  });

  try {
    if (pages.dataset.loaded !== 'true') {
      const currentPage = Number(pages.dataset.currentPage);
      const totalPages = Number(pages.dataset.totalPages);
      const pageParam = pages.dataset.pageParam || 'page';

      if (
        !sectionId ||
        !Number.isInteger(currentPage) ||
        !Number.isInteger(totalPages) ||
        currentPage < 1 ||
        totalPages < currentPage
      ) {
        throw new Error('Invalid pagination information');
      }

      const cardsByPage = new Map();
      cardsByPage.set(
        currentPage,
        [...grid.querySelectorAll(':scope > [data-shirt-kind]')]
      );

      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) continue;

        status.textContent =
          `Loading products, page ${page} of ${totalPages}…`;

        const pageUrl = new URL(window.location.href);
        pageUrl.hash = '';
        pageUrl.searchParams.delete('sections');
        pageUrl.searchParams.set('section_id', sectionId);
        pageUrl.searchParams.set(pageParam, String(page));

        const response = await fetch(pageUrl.toString(), {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error('Could not load a product page');
        }

        const html = await response.text();
        const documentPage = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        const fetchedSection = [
          ...documentPage.querySelectorAll('results-list')
        ].find((item) => item.getAttribute('section-id') === sectionId);

        const fetchedPages = fetchedSection?.querySelector(
          '[data-shirt-pages]'
        );

        if (
          !fetchedPages ||
          Number(fetchedPages.dataset.currentPage) !== page ||
          Number(fetchedPages.dataset.totalPages) !== totalPages
        ) {
          throw new Error('Unexpected pagination response');
        }

        const fetchedCards = [
          ...fetchedSection.querySelectorAll(
            '.product-grid > [data-shirt-kind]'
          )
        ];

        if (!fetchedCards.length) {
          throw new Error('Product cards were not returned');
        }

        cardsByPage.set(page, fetchedCards);
      }

      // Only change the grid after every page loads successfully.
      if (!section.isConnected) return;

      const fragment = document.createDocumentFragment();
      const seenProducts = new Set();

      for (let page = 1; page <= totalPages; page += 1) {
        for (const card of cardsByPage.get(page) || []) {
          const productId = card.dataset.productId;
          if (seenProducts.has(productId)) continue;

          seenProducts.add(productId);
          fragment.appendChild(card);
        }
      }

      grid.appendChild(fragment);
      pages.dataset.loaded = 'true';

      section.querySelectorAll('[data-shirt-pagination]').forEach(
        (pagination) => {
          pagination.hidden = true;
        }
      );
    }

    let visibleCount = 0;

    grid.querySelectorAll(':scope > [data-shirt-kind]').forEach(
      (card) => {
        const matches =
          choice === 'all' || card.dataset.shirtKind === choice;

        card.hidden = !matches;
        if (matches) visibleCount += 1;
      }
    );

    buttons.forEach((item) => {
      item.setAttribute('aria-pressed', String(item === button));
    });

    status.textContent = visibleCount
      ? `${visibleCount} products`
      : 'No products match this type.';
  } catch (error) {
    console.error('Shirt filter:', error);
    status.textContent =
      'Could not load all products. Please try again. The filter has not been changed.';
  } finally {
    controls.dataset.loading = 'false';
    controls.removeAttribute('aria-busy');

    buttons.forEach((item) => {
      item.disabled = false;
    });
  }
});


  } catch(e) { console.error(e); }
})();
})();
